import { mostraAlertaError, mostraAlertaOk, mostraAlertaPregunta } from "../../../../componentes/alerts/sweetAlert";
import { useEffect, useState } from "react"
import { AxiosPrivado } from "../../../../componentes/axios/Axios";
import { ProductosTiposEliminar, ProductosTiposListar } from "../../../../configuracion/apiUrls";

const EliminarTipoProducto = ({ datos, token, setListaTiposProductos, ActualizarLista }) => {
    const [eliminar, setEliminar] = useState(false);

    useEffect(()=>{
        if(eliminar)
            eliminarTipoProducto();
    },[eliminar])
    const eliminarTipoPregunta = async (f) =>{
        mostraAlertaPregunta(setEliminar, "¿Deseas eliminar el tipo de producto "+ datos.nombre +" de forma permanente?", "warning");
    }
  
    const eliminarTipoProducto = async () =>{
        if (!datos.id)
            mostraAlertaError("Seleccione un tipo de prodcuto");
        else {
            try {
                AxiosPrivado.defaults.headers.common['Authorization'] = `Bearer ${token}`;
                AxiosPrivado.delete(ProductosTiposEliminar + datos.id)
                    .then((respuesta) => {
                        ActualizarLista(ProductosTiposListar, setListaTiposProductos);
                        mostraAlertaOk("Registro eliminado correctamente");
                    }).catch((er) => {
                        console.log(er);
                        var msjError = "";
                        switch (er.response.status) {
                            case 400:
                                if (er.response.data && Array.isArray(er.response.data)) {
                                    er.response.data.map(f => {
                                        msjError += f.msg + '. '
                                    })
                                }
                                break;
                            case 400:
                                msjError = er.response.data.error;
                                break;
                            case 500:
                                msjError = er.response.data.error;
                                break;
                            default:
                                msjError = "Ocurrió un error desconocido.";
                                break;
                        }
                        mostraAlertaError(msjError, "error");
                    })
            } catch (error) {
                mostraAlertaError("Error en la pedición")
            }
        }
        setEliminar(false);
    }
    
    return (
        <button type="button" className="btn btn-outline-danger" onClick={eliminarTipoPregunta}>
            <i className="fas fa-trash" />
        </button>
    );
}
export default EliminarTipoProducto;